import { 
    FETCH_ALL_OPERATORS,
    FETCH_ALL_OPERATORS_SUCCESS,
    FETCH_ALL_OPERATORS_FAILED,
  } from "../store/types";
  
  export const INITIAL_STATE = {
    operators:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const operatorsreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_OPERATORS:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_OPERATORS_SUCCESS:
        return {
          ...state,
          operators:action.payload,
          loading:false
        };
      case FETCH_ALL_OPERATORS_FAILED:
        return {
          ...state,
          operators:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };